(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hgg-halloween"]) return;
  try {
    
(function() {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var spiderSwings = new WeakMap();
  function exciteSpider(spider) {
    if (reducedMotion.matches) return;
    var startingTransform = getComputedStyle(spider).transform;
    clearTimeout(spiderSwings.get(spider));
    spider.classList.remove('hgg-spider-settling');
    spider.style.setProperty('--hgg-spider-start', startingTransform);
    void spider.getBoundingClientRect();
    spider.classList.add('hgg-spider-settling');
    spider.setAttribute('data-swing', 'settling');
    var timer = setTimeout(function() {
      spider.classList.remove('hgg-spider-settling');
      spider.style.removeProperty('--hgg-spider-start');
      spider.removeAttribute('data-swing');
      spiderSwings.delete(spider);
    }, 12000);
    spiderSwings.set(spider, timer);
  }
  document.addEventListener('click', function(event) {
    var spider = event.target.closest('.hgg-halloween-spider');
    if (spider) exciteSpider(spider);
  });
  document.addEventListener('keydown', function(event) {
    var spider = event.target.closest('.hgg-halloween-spider');
    if (spider && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      exciteSpider(spider);
    }
  });
  var pointerStart = null;
  var lastBurst = 0;
  var burstLayer = null;
  function removeBursts() {
    if (burstLayer) burstLayer.remove();
    burstLayer = null;
  }
  function burst(x, y) {
    var shape = document.getElementById('hgg-bat-shape');
    if (!shape || reducedMotion.matches || Date.now() - lastBurst < 220) return;
    lastBurst = Date.now();
    if (!burstLayer || !burstLayer.isConnected) {
      burstLayer = document.createElement('div');
      burstLayer.className = 'hgg-bat-burst-layer';
      burstLayer.setAttribute('aria-hidden', 'true');
      document.body.appendChild(burstLayer);
    }
    if (!burstLayer.animate) return;
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var count = mobile ? 2 : 3;
    while (burstLayer.childElementCount > 9) burstLayer.firstElementChild.remove();
    for (var i = 0; i < count; i++) {
      var bat = document.createElement('div');
      bat.className = 'hgg-bat-flight';
      bat.appendChild(shape.content.cloneNode(true));
      var size = mobile ? 25 + Math.random() * 5 : 30 + Math.random() * 8;
      bat.style.width = size + 'px';
      bat.style.height = size / 2 + 'px';
      burstLayer.appendChild(bat);
      var spread = count === 2 ? (i === 0 ? -1 : 1) : i - 1;
      var dx = spread * (mobile ? 90 : 145) + (Math.random() - .5) * 45;
      var dy = -(mobile ? 115 : 175) - Math.random() * 85;
      var originX = x - size / 2;
      var originY = y - size / 4;
      var tilt = spread * 16;
      var frames = [
        { offset:0, transform:'translate(' + originX + 'px,' + originY + 'px) scale(.75)', opacity:1 },
        { offset:.12, transform:'translate(' + (originX + dx * .12) + 'px,' + (originY + dy * .12) + 'px) scale(1) rotate(' + tilt + 'deg)', opacity:1 },
        { offset:.65, transform:'translate(' + (originX + dx * .65) + 'px,' + (originY + dy * .6) + 'px) scale(.9) rotate(' + (-tilt * .4) + 'deg)', opacity:1 },
        { offset:1, transform:'translate(' + (originX + dx) + 'px,' + (originY + dy) + 'px) scale(.5) rotate(' + tilt + 'deg)', opacity:0 }
      ];
      var animation = bat.animate(frames, { duration:1150 + Math.random() * 350, easing:'ease-out', fill:'forwards' });
      animation.onfinish = (function(el) { return function() { el.remove(); }; })(bat);
    }
  }
  document.addEventListener('pointerdown', function(event) {
    pointerStart = event.isPrimary && event.button === 0 ? { id:event.pointerId, x:event.clientX, y:event.clientY } : null;
  }, { passive:true, capture:true });
  document.addEventListener('pointerup', function(event) {
    var start = pointerStart;
    pointerStart = null;
    if (!start || start.id !== event.pointerId || !event.isPrimary) return;
    if (Math.hypot(event.clientX - start.x, event.clientY - start.y) > 12) return;
    if (event.target.closest('input,textarea,select,[contenteditable="true"]')) return;
    burst(event.clientX, event.clientY);
  }, { passive:true, capture:true });
  document.addEventListener('pointercancel', function() { pointerStart = null; }, { passive:true });
  function decorate() {
    removeBursts();
    document.querySelectorAll('.hgg-halloween-header,.hgg-halloween-hero').forEach(function(el) { el.remove(); });
    var headerTemplate = document.getElementById('hgg-halloween-header');
    var header = document.querySelector('.header-wrapper');
    if (headerTemplate && header) {
      if (getComputedStyle(header).position === 'static') header.style.position = 'relative';
      header.appendChild(headerTemplate.content.cloneNode(true));
    }
    var heroTemplate = document.getElementById('hgg-halloween-hero');
    var hero = document.querySelector('#MainContent slideshow-component .relative');
    if (heroTemplate && hero) {
      if (getComputedStyle(hero).position === 'static') hero.style.position = 'relative';
      hero.appendChild(heroTemplate.content.cloneNode(true));
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', decorate);
  else decorate();
  document.addEventListener('shopify:section:load', decorate);
  reducedMotion.addEventListener('change', decorate);
  window.addEventListener('pagehide', removeBursts);
  window.addEventListener('pageshow', decorate);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hgg-product-spotlight"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hgg-spotlight')) {
    customElements.define('hgg-spotlight', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const track = this.querySelector('.hgg-spotlight__track');
        const controls = this.querySelector('.hgg-spotlight__controls');
        const buttons = [...controls.querySelectorAll('button')];
        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          const offset = Math.abs(track.scrollLeft);
          controls.hidden = max < 2;
          buttons[0].disabled = offset < 2;
          buttons[1].disabled = offset >= max - 2;
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          const rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
          track.scrollBy({ left: Number(button.dataset.direction) * rtl * (track.clientWidth * .85), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }, { signal }));
        track.addEventListener('scroll', update, { signal, passive: true });
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ios26-glass-mobile-menu"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.glass-mobile-nav__surface').forEach((surface) => {
      if (surface.dataset.dragReady === 'true') return;
      surface.dataset.dragReady = 'true';

      const mobileNav = surface.closest('.glass-mobile-nav');

      if (mobileNav && mobileNav.parentElement !== document.body) {
        document.body.appendChild(mobileNav);
      }

      const lens = surface.querySelector('.glass-mobile-nav__lens');
      const items = Array.from(surface.querySelectorAll('.glass-mobile-nav__item'));
      let activeIndex = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
      let startX = 0;
      let lensStartX = 0;
      let currentX = 0;
      let dragging = false;
      let moved = false;

      const metrics = () => {
        const rect = surface.getBoundingClientRect();
        return { slot: (rect.width - 8) / items.length, max: ((rect.width - 8) / items.length) * (items.length - 1) };
      };

      const setActive = (index) => {
        activeIndex = Math.max(0, Math.min(items.length - 1, index));
        items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === activeIndex));
      };

      const placeLens = (x, scale = 1) => {
        currentX = x;
        lens.style.transform = `translate3d(${x}px, 0, 0) scaleX(${scale})`;
      };

      const snap = (index, navigate = false) => {
        const { slot } = metrics();
        setActive(index);
        surface.classList.remove('is-dragging');
        surface.classList.add('is-settling');
        placeLens(slot * activeIndex, 1);
        window.setTimeout(() => {
          surface.classList.remove('is-settling');
          if (navigate) window.location.assign(items[activeIndex].href);
        }, 340);
      };

      const begin = (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        const { slot } = metrics();
        dragging = true;
        moved = false;
        startX = event.clientX;
        lensStartX = slot * activeIndex;
        surface.classList.remove('is-settling');
        surface.classList.add('is-dragging');
        surface.setPointerCapture(event.pointerId);
      };

      const move = (event) => {
        if (!dragging) return;
        const { slot, max } = metrics();
        const delta = event.clientX - startX;
        if (Math.abs(delta) > 2) moved = true;
        const rawX = lensStartX + delta;
        const resistedX = rawX < 0 ? rawX * .18 : rawX > max ? max + (rawX - max) * .18 : rawX;
        const velocityStretch = 1 + Math.min(Math.abs(delta) / slot, 1) * .08;
        placeLens(resistedX, velocityStretch);
        setActive(Math.round(Math.max(0, Math.min(max, resistedX)) / slot));
      };

      const end = (event) => {
        if (!dragging) return;
        dragging = false;
        if (surface.hasPointerCapture(event.pointerId)) surface.releasePointerCapture(event.pointerId);
        snap(activeIndex, moved);
      };

      surface.addEventListener('pointerdown', begin);
      surface.addEventListener('pointermove', move);
      surface.addEventListener('pointerup', end);
      surface.addEventListener('pointercancel', end);
      surface.addEventListener('click', (event) => {
        if (moved) event.preventDefault();
      }, true);

      window.addEventListener('resize', () => snap(activeIndex));
      requestAnimationFrame(() => snap(activeIndex));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
